export default function PHP_fetch_all() {
  return (
    <div>
      <h1>PHP_fetch_all</h1>
    </div>
  );
}
